import { Spin } from "antd";
import "./CustomSpinner.css";
export const CustomSpinner = () => {
    return (
        <div className="CustomSpinner">
            <Spin />
        </div>
    )
};